import moment from 'moment';

const DefaultTimeFormat = 'YYYY-MM-DD HH:mm:ss';
const pCurTime = sessionStorage.getItem('sCurrentTime') ?? '';
const datetime = {
    getCurrTime: (addSec: number = 0) => {
        return moment().add(addSec, 'seconds').format(DefaultTimeFormat);
    },
    getAddSecTime: (time: string, addSec: number, format: string = DefaultTimeFormat) => {
        return moment(new Date(time)).add(addSec, 'seconds').format(format);
    },
    getTimecode: (time: string, format: string = DefaultTimeFormat) => {
        try {
            return moment(new Date(time)).format(format);
        } catch (error) {
            return time;
        }
    },
    getEndTime: (startTime: string, timTime: string, addSec: number = 0) => {
        /**
         * 시작 시간(startTime): 'YYYY-MM-DD HH:mm:ss'
         * 타이머 (timTime): 'mm:ss' (TODO HH:mm:ss)
         * 추가 시간 (addSec)
         * 종료 시간 = 시작 시간 + 타이머 시간 + 추가 시간
         * 만료 시간 (expiredTime)
         * return : 만료 시간 < 종료 시간 ? 만료 시간 : 종료 시간
         * (종료 시간이 만료 시간 이후일때 만료시간 반환)
         */
        try {
            const tArr = timTime.split(':');
            let tSec = 0;
            if (tArr.length == 3) {
                // HH:mm:ss
                tSec = Number(tArr[0]) * 60 * 60 + Number(tArr[1]) * 60 + Number(tArr[2]);
            } else if (tArr.length === 2) {
                // mm:ss
                tSec = Number(tArr[0]) * 60 + Number(tArr[1]);
            }
            const start = new Date(startTime);
            const sTime = start.getTime();
            const endTime = sTime + tSec * 1000 + addSec * 1000;
            // if(expiredTime != undefined) {
            //     const exTime = new Date(expiredTime).getTime();
            //     return exTime < endTime ? exTime : endTime;
            // }
            return endTime;
        } catch (e) {
            throw new Error('getEndTime Error');
        }
    },
    getEndTimecode: (startTime: string, timTime: string, addSec: number = 0) => {
        try {
            const eTime = datetime.getEndTime(startTime, timTime, addSec);
            return moment(eTime).format(DefaultTimeFormat);
        } catch (e) {
            throw new Error('getEndTime Error');
        }
    },
    getRemainingSeconds: (
        startTime: string,
        timTime: string,
        addSec: number = 0,
        currentTime?: string
    ): number => {
        /**
         * startTime: 'YYYY-MM-DD HH:mm:ss'
         * timTimee: 'mm:ss' (TODO HH:mm:ss)
         */
        try {
            const eTime = datetime.getEndTime(startTime, timTime, addSec);
            const now = new Date(currentTime || pCurTime);
            const remainingTime = eTime - now.getTime();
            if (remainingTime > 0) {
                return Math.round(remainingTime / 1000);
            }
        } catch (e) {
            throw new Error('getRemainingSeconds Error');
        }
        return 0;
    },
    getSecToTimecode: (sec: number): string => {
        try {
            return moment.utc(sec * 1000).format('HH:mm:ss');
        } catch (e) {
            throw new Error('getSecToTimecode Error');
        }
    },

    formatTime: (regDt: string) => {
        moment.locale('ko');
        if (!regDt) return '';

        const now = moment();
        const regDate = moment(regDt);
        const diffInSeconds = now.diff(regDate, 'seconds');

        if (diffInSeconds < 60) {
            return '지금';
        } else {
            return regDate.fromNow();
        }
    },

    isCurrentlyLate: (standardTime?: string): boolean => {
        if (!standardTime) return true;
        try {
            const curr = new Date(pCurTime);
            const time = new Date(standardTime);
            return time.getTime() < curr.getTime();
        } catch (error) {
            return true;
        }
    },

    getDefaultEvalDate: (currTime: string): string => {
        const now = new Date(currTime);
        const m = now.getMinutes();
        const addM = (5 - (m % 5)) % 5;
        return moment(now).add(addM, 'minutes').format(DefaultTimeFormat);
    },

    formatDateString: (dateString: string): string => {
        if (dateString.length !== 8 || !/^\d+$/.test(dateString)) {
            throw new Error('Invalid date string');
        }

        const year = dateString.substring(2, 4);
        const month = dateString.substring(4, 6);
        const day = dateString.substring(6, 8);

        return `${year}-${month}-${day}`;
    },
    getEvalHomeRemainTime: (endTime?: string, timer?: string, useTime?: number): string => {
        const [h, m, s] = timer?.split(':').map(Number) || [0, 0, 0];
        const timerMs = h * 3600_000 + m * 60_000 + s * 1_000;
        const usedMs = useTime ? useTime * 1_000 : 0;
        const availTimerMs = Math.max(0, timerMs - usedMs);
        const remainEvalMs = moment(endTime).diff(moment());
        const useMs = Math.max(0, Math.min(availTimerMs, remainEvalMs));

        return moment.utc(useMs).format('HH:mm:ss');
    },
};

export default datetime;
